export const formatValueToCsvString = <TValue>(
  value: TValue | TValue[],
  formatValue: (value: TValue) => string,
): string =>
  Array.isArray(value) ? value.map(formatValue).join(', ') : formatValue(value);
